module.exports = __webpack_public_path__ + "static/ezflo-428f1263c7824420e7a131594db75334.png";